<template>
  <div class="report-user-content analytics-system-content">
  
      <b-card no-body class="card-analytics-system-content">
        <b-card-header class="statistics-filter-header">
          Filtro
        </b-card-header>
        <b-card-body>
          
          <div class="analytics-system-content-filter">
            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="origin-list"
                  v-model="originFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Origin')"
                  :options="origins"
                  multiple
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="subject-list"
                  v-model="subjectFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Subject')"
                  :options="subjects"
                  multiple
                  :closeOnSelect="false"
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="subject-list"
                  v-model="contentFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Content')"
                  :options="contents"
                  multiple
                  :closeOnSelect="false"
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>
            <div class="flex col-md-6 calendar-analytics-system-content">
              <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
              <flat-pickr
                v-model="rangePicker"
                class="form-control-sm form-date"
                :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                :config="{
                  enableTime: false,
                  dateFormat: 'Y-m-d',
                  altInput: true,
                  altFormat: 'd/m/Y',
                  allowInput: true,
                  mode: 'range',
                }"
              />
            </div>
          </div>
          <div class="analytics-system-content-buttons">
            <b-button
              variant="primary"
              size="sm"
              @click="fetchData()"
            >
            <feather-icon icon="SearchIcon" class="export-button-icon"/>
              {{ $t("MANAGE_NEWS_FILTER.Search") }}
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="reportData()"
            >
              <feather-icon icon="FileTextIcon" class="export-button-icon"/>
              Exportar
            </b-button>
            <b-button 
              variant="primary"
              size="sm" 
              @click="onClear"
            >
              <feather-icon icon="TrashIcon" class="export-button-icon"/>
              {{ $t('MANAGE_NEWS_FILTER.Clear') }}
            </b-button>
          </div>
          
        </b-card-body>
        
      </b-card>
      <div v-if="listData" class="analytics-system-content-body">
        <vue-perfect-scrollbar
          class="report-user-scroll-area"
          :suppressScrollX="true"
        >
          <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
            <div v-if="listData.dataResp && listData.dataResp.length > 0">
              <app-collapse
                accordion
                type="margin"
                not-arrow
              >
                <app-collapse-item
                  title="" 
                  v-for="(item, index) in listData.dataResp" 
                  :key="index"
                >
                  <div 
                    slot="header" 
                    class="d-flex justify-content-between align-items-center"
                    @click="toggleCard(index)"
                  >
                    {{ `${item.subjectName} - ${item.total} acessos` }}
                    <span >
                      <feather-icon :icon="getChevronIcon(index)" size="18"/>
                    </span>
                  </div>
                  <div>
                    <b-row>
                      <b-col md="2"><b>Conteúdo</b></b-col>
                      <b-col md="3"><b>Quantidade de acessos</b></b-col>
                    </b-row>
                    <hr>
                    <b-row v-for="(content, index) in item.content" :key="index" class="config-email-row">
                      <b-col md="3">{{content.name}}</b-col>
                      <b-col md="3">{{content.totalContent}}</b-col>
                    </b-row>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>
            <div v-else>
              Nenhum registro encontrado
            </div>
          </b-overlay>
        </vue-perfect-scrollbar>
      </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  // BBadge,
  BFormGroup,
  // BCardTitle,
  BButton,
  BOverlay,
  BRow,
  BCol
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import newsReportService from "@/providers/newsReportService";
import { ref } from "@vue/composition-api";
import dropdownService from "@/providers/dropdownService";
import AppConstants from "@/appConstants";
import vSelect from "vue-select";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import { formatDate } from "@core/utils/filter";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import flatPickr from "vue-flatpickr-component";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    VuePerfectScrollbar,
    BCardHeader,
    BCard,
    // BBadge,
    BCardBody,
    flatPickr,
    BFormGroup,
    vSelect,
    // BCardTitle,
    BButton,
    BOverlay,
    BRow,
    BCol
  },
  data() {
    return {
      openItems: {}
    };
  },
  computed: {

  },
  watch: {
  },
  methods: {
    toggleCard(index) {
      this.$set(this.openItems, index, !this.openItems[index]);
    },
    getChevronIcon(index) {
      return this.openItems[index] ? 'ChevronUpIcon' : 'ChevronDownIcon';
    }
  },
  setup() {
    const displayOverlay = ref(false);
    // const rangePicker = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePicker = ref("");
    const origins = ref([]);
    const subjects = ref([]);
    const contents = ref([]);

    const originFilter = ref([]);
    const subjectFilter = ref([]);
    const contentFilter = ref([]);

    const listData = ref([]);

    const limit = AppConstants.PAGINATOR_DEFAULT_LIMIT;
    const page = 1;

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };

    const fetchFilter = () => {
      const originParams = new URLSearchParams();
      originParams.append('code', 250);
      const subjectParams = new URLSearchParams();

      dropdownService.getAllOrigin(originParams).then(res => {
        origins.value = res;
        originFilter.value = res;
        subjectParams.append('origins', originFilter.value.map((item) => item.id).join(","));
        Promise.all([
          dropdownService.getAllSubjects(subjectParams),
          dropdownService.getContent(subjectParams),
        ]).then((resp) => {
          subjects.value = resp[0];
          contents.value = resp[1];
        });

      })

    };

    const buildParams = () => {
      const params = new URLSearchParams();
      if (originFilter.value) {
        params.append(
          "source",
          originFilter.value.map((item) => item.id).join(",")
        );
      }
      if (subjectFilter.value) {
        params.append(
          "subject",
          subjectFilter.value.map((item) => item.id).join(",")
        );
      }
      if (contentFilter.value) {
        params.append(
          "content",
          contentFilter.value.map((item) => item.id).join(",")
        );
      }
      
      return params;
    };

    const fetchData = () => {
      const params = buildParams();
      params.append("dt_range", rangePicker.value);
      newsReportService.getAnalyticsSystemContent(params)
      .then((resp) => {
        listData.value = resp;
      });
    };

    const reportData = () => {
      const params = buildParams();
      params.append('page', page);
      params.append('limit', limit);
      
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      if (!rangePicker.value || rangePicker.value <= 0) {
        messagesNotifyHelper.errorNotify(
          "Erro",
          "Filtro Período obrigatório"
        );
        return;
      }
      params.append("download", true);
      newsReportService
        .reportAnalyticsSystemContent(params)
        .then((response) => {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'estatistica-assunto-conteudo.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((error) => {
          console.log(error);
          if (error.message) {
            messagesNotifyHelper.errorNotify("Erro", error.message);
          } else {
          messagesNotifyHelper.errorNotify("Erro", "Sem dados para exportar, verifique sua pesquisa e tente novamente");
          }
        });
    };
    const onClear= () => {
      rangePicker.value = "";
      originFilter.value = [];
      subjectFilter.value = [];
      contentFilter.value = [];
    };


    fetchFilter();

    return {
      // variables
      displayOverlay,
      perfectScrollbarSettings,
      rangePicker,
      origins,
      subjects,
      contents,

      originFilter,
      subjectFilter,
      contentFilter,
      listData,

      // methods
      fetchData,
      formatDate,
      reportData,
      onClear
    };
  },
};
</script>

<style>

.analytics-system-content .calendar-analytics-system-content {
  /* margin-bottom: 15px; */
  padding-left: 25px;
  padding-right: 25px;
}

.calendar-analytics-system-content .form-control-sm {
  height: 100%;
}

.analytics-system-content-buttons {
  padding: .5rem;
}

.analytics-system-content-buttons button {
  margin-right: 10px;
}

.analytics-system-content-body {
  padding: 15px;
  height: 100%;
  max-height: 65%;
}

.analytics-system-content-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.analytics-system-content-body span {
  margin-left: 15px;
}


</style>
